export namespace Credentials {
  export interface ICredentials {
    id: number;
    type: number;
    login: string;
    password: string;
  }

  export class Credentials implements ICredentials {
    id: number = 0;
    type: number = 0;
    login: string = "";
    password: string = "";
  }

  export interface ISystemCredentials {
    id: number;
    displayName: string;
    photoUrl: string;
    nickname: string;
    publicId: string;
    email: string;
    contactMobilePhone: string;
    pass: string;
    /** Origem do login: Portal (0) ou App (1). */
    accessSource?: number;
  }

  export class SystemCredentials implements ISystemCredentials {
    id: number = 0;
    displayName: string = "";
    photoUrl: string = "";
    nickname: string = "";
    publicId: string = "";
    email: string = "";
    contactMobilePhone: string = "";
    pass: string = "";
    accessSource: number = 0;
  }

  export interface INewPassword {
    application: string;
    credentialType: number;
    credentialsId: number;
    login: string;
    password: string;
    userId: string;
    route: string;
    accessToken: string;
    destinyNumber: string;
    newPassword: string;
  }

  export class NewPassword implements INewPassword {
    application: string = "MyGroomer";
    credentialType: number = 0;
    credentialsId: number = -1;
    login: string = "";
    password: string = "";
    userId: string = "";
    route: string = "";
    accessToken: string = "";
    destinyNumber: string = "";
    newPassword: string = "";
  }
}
